import { classesBuilder } from '@common/helpers';
import Icon from '@components/Icon';

import type { ITimelineItemProps } from './types';

import style from './styles.module.scss';

export const TimelineItem = ({ title, description, isActive, isLineActive, showLine, iconRef }: ITimelineItemProps) => {
  return (
    <div className={classesBuilder(style['timeline-item'], { [style.active]: isActive })}>
      <div className={style['timeline-graphic-col']}>
        <div
          ref={iconRef}
          className={classesBuilder(style['icon-box'], { [style.active]: isActive })}
        >
          <Icon
            name="sparkle"
            className={style['timeline-icon']}
          />
        </div>
        {showLine && (
          <div
            className={classesBuilder(style['connector-line'], {
              [style.active]: isLineActive,
            })}
          />
        )}
      </div>
      <div className={style['timeline-content-col']}>
        <h2 className={style['timeline-title']}>{title}</h2>
        <p className={style['timeline-description']}>{description}</p>
      </div>
    </div>
  );
};
